import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/queryKeys";
import {
  Loader,
  Message,
  Modal,
  SelectPicker,
  Uploader,
  useToaster,
} from "rsuite";
import Button from "../button";
import {
  useQuoteUploadMetaData,
  useQuoteUploadSubmit,
} from "../../react-query/hooks/HQuoteUpload";
import {
  ICombinedQuoteSubmitPayload,
  IQuoteUploadPayload,
  IQuoteUploadStatusPayload,
} from "../../services/interfaces/IQuoteUpload";
import { FileType, UploaderProps } from "rsuite/esm/Uploader";
import FileUploadIcon from "@rsuite/icons/FileUpload";
import { JsxElement } from "typescript";

interface ICustomModalProps {
  openModal: boolean;
  closeModal: () => void;
  isloading: boolean;
  header?: React.ReactNode;
  footer?: string | undefined;
  closeable?: boolean;
  children: React.ReactNode;
  size?: string;
}

const CustomModal = ({
  openModal,
  closeModal,
  isloading,
  header,
  footer,
  closeable = true,
  children,
  size = "xs",
}: ICustomModalProps) => {
  const toaster = useToaster();

  return (
    <div className="flex justify-center items-center vol-alloc-custom-modal">
      <Modal
        className="w-[30vw] quote-upload-modal"
        open={openModal}
        onClose={() => {
          !isloading && closeModal();
        }}
        backdrop="static"
        keyboard={false}
        size={size}
      >
        <Modal.Header closeButton={closeable}>
          <Modal.Title className="font-bold text-[1.05vw] pb-[0.5vh]">
            {header}
          </Modal.Title>
        </Modal.Header>

        {isloading ? (
          <Modal.Body style={{ minHeight: "42.5vh" }}>
            <Loader
              backdrop
              content="Loading..."
              size="md"
              vertical
              className="text-black font-bold"
              style={{ opacity: 0.6, minHeight: "20vh" }}
            />
          </Modal.Body>
        ) : (
          <>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer>
              <div className="flex justify-center text-fs14">{footer}</div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </div>
  );
};

export default CustomModal;
